import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TemplateInfoDTO } from "@shared/model/template.model";

export class TemplateData {
	templates: TemplateInfoDTO[];
	selected: TemplateInfoDTO;
}

@Component({
	selector: "app-template-selector",
	templateUrl: "./template-selector.component.html",
	styleUrl: "./template-selector.component.scss",
	standalone: false
})
export class TemplateSelectorComponent {
	selected: TemplateInfoDTO;

	constructor(
		public dialogRef: MatDialogRef<TemplateSelectorComponent>,
		@Inject(MAT_DIALOG_DATA) public data: TemplateData) {
	}

	onClose(element: any): void {
		this.dialogRef.close(element);
	}

	selectRole(element: any) {
		this.data.selected = element.value;
		this.onClose(element.value);
	}
}